module.exports = __webpack_public_path__ + "img/nav-home.f46fa3ec.svg";